import sliceCreator from '../../index.js';
import {DELETE_ADMIN} from '../../../constants/index.js';
const _deleteAdminAction = sliceCreator('DELETE_ADMIN', DELETE_ADMIN, 'delete');

const { asyncAction: deleteAdminAction, reducer, clearData: clearDeleteAdminAction } = _deleteAdminAction;

export default reducer;

export {
    deleteAdminAction,
    clearDeleteAdminAction
}